<template>
    <v-tab-item>
        <v-sheet v-if="!questions.length" class="d-flex flex-column align-center justify-center"> 추가질문답변이 없습니다. </v-sheet>
        <template v-else>
            <v-sheet class="mt-n40 mt-lg-n60">
                <question-item v-for="(value, index) in questions" :key="value.question._id" v-bind="{ value, index }" readonly class="mt-40 mt-lg-60" />
            </v-sheet>
        </template>
    </v-tab-item>
</template>

<script>
import { RECRUITMENT_QUESTION_TYPES } from "@/assets/variables";

import QuestionItem from "@/components/client/application/questions/question-item.vue";

export default {
    components: {
        QuestionItem,
    },
    props: {
        value: { type: Object, default: () => ({}) }, // application
    },
    data: () => ({
        RECRUITMENT_QUESTION_TYPES,
    }),
    computed: {
        questions() {
            return this.value?.questions;
        },
    },
};
</script>

<style></style>
